import { createFileRoute } from '@tanstack/react-router'
import { RatingsLayout } from '@/features/ratings/components/ratings-layout'

export const Route = createFileRoute('/_authenticated/ratings')({
  component: RatingsLayout,
})
